import { TextProps, parseContent } from '@features/powerpoint';
import { theme } from '../domain/theme';

export const contentSlideTitleText = (title: string): TextProps => ({
  text: parseContent(title, 0, {
    color: theme.colors.white,
  }),
  options: {
    fontSize: 28,
    h: 0.57,
    w: 11.83,
    x: 0.74,
    y: 0.74,
  },
});
